const key = Symbol("clickoutside");

function createDocumentHandler(el: HTMLElement, binding: any, vnode: any) {
  return function(mouseup: MouseEvent, mousedown: MouseEvent) {
    if (
      !vnode ||
      !vnode.context ||
      !mouseup?.target ||
      !mousedown?.target ||
      el.contains(mouseup?.target as HTMLElement) ||
      el.contains(mousedown?.target as HTMLElement) ||
      el === mouseup.target ||
      (vnode.context.popperElm &&
        (vnode.context.popperElm.contains(mouseup?.target) ||
          vnode.context.popperElm.contains(mousedown?.target)))
    )
      return;

    if (
      binding.expression &&
      el[key].methodName &&
      vnode.context[el[key].methodName]
    ) {
      vnode.context[el[key].methodName]();
    } else {
      el[key].bindingFn && el[key].bindingFn();
    }
  };
}

const nodeList: HTMLElement[] = [];
let startClick: any;
let seed = 0;

document.addEventListener("mousedown", e => (startClick = e));
document.addEventListener("mouseup", e => {
  nodeList.forEach(node => node[key].documentHandler(e, startClick));
});

export default {
  bind(el: HTMLElement, binding: any, vnode: any) {
    nodeList.push(el);
    const id = seed++;
    el[key] = {
      id,
      documentHandler: createDocumentHandler(el, binding, vnode),
      methodName: binding.expression,
      bindingFn: binding.value
    };
  },

  update(el: HTMLElement, binding: any, vnode: any) {
    el[key].documentHandler = createDocumentHandler(el, binding, vnode);
    el[key].methodName = binding.expression;
    el[key].bindingFn = binding.value;
  },

  unbind(el: HTMLElement) {
    const len = nodeList.length;
    for (let i = 0; i < len; i++) {
      if (nodeList[i][key].id === el[key].id) {
        nodeList.splice(i, 1);
        break;
      }
    }
    delete el[key];
  }
};
